import { render, staticRenderFns } from "./404.vue?vue&type=template&id=8fc51f94&scoped=true&"
import script from "./404.vue?vue&type=script&lang=js&"
export * from "./404.vue?vue&type=script&lang=js&"
import style0 from "./404.vue?vue&type=style&index=0&id=8fc51f94&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc51f94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fc51f94')) {
      api.createRecord('8fc51f94', component.options)
    } else {
      api.reload('8fc51f94', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=8fc51f94&scoped=true&", function () {
      api.rerender('8fc51f94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/errorPage/404.vue"
export default component.exports